import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CONSTANT, ErrorService, NotificationService, TYPEMESSAGE } from '../session/index';
//import { IContrato } from '../../modulos/contrato/contrato/shared/contrato.model';
import { LoaderService } from '../loader/loader.service';
//import { ContratoService } from '../../modulos/contrato/contrato/shared/contrato.service';
//import { PromotorService } from '../../modulos/contrato/contrato/promotor/shared/promotor.service';
import { CommonCboService } from '../common/commoncbo.service';
import { ButtonreasonComponent } from '../buttonreason/buttonreason.component';
//import { PrefacturaService } from '../../modulos/prefactura/manual/shared/prefactura.service';
//import { EVENTO } from '../../modulos/prefactura/manual/shared/constant';
//import { CronogramaService } from '../../modulos/contrato/contrato/cronograma/shared/cronograma.service';

@Component({
	selector: 'app-titlebar',
	templateUrl: './titlebar.component.html',
	styleUrls: ['./titlebar.component.css']
})
export class TitlebarComponent implements OnInit {
	@Input() iCancel: boolean;
	@Input() eventCancel: any;
	@Input() iEdit: boolean;
	@Input() eventEdit: any;
	@Input() iBack: boolean;
	@Input() eventBack: any;
	@Input() eventReview:any;
	@Input() iClose: boolean;
	@Input() iCloseEvent: boolean;
	@Input() eventClose: string;
	@Input() eventCloseEvent: any;

	@Input() msgTitle: any;
	@Input() msgEditar: string;
	@Input() data: any;

	// TODO:Inicio: @Input de prueba,DHH - No Borrar
	@Input() boolSidebar: any;
	@Input() claseDinamica: any;
	// TODO:Fin: @Input de prueba,DHH - No Borrar

	@Input() iAnularContrato: boolean;
	@Input() iTerminarContrato: boolean;
	@Input() iDarBaja: boolean;
	@Input() iRenovar: boolean;
	@Input() iEliminar: boolean;

	@Input() iAnularPrefactura: boolean;
	@Input() iEnviarERP: boolean;

	@Input() loadMotivos: boolean;
	@Input() iRegeneraCronograma: boolean;

	@Output() iAnularBtnClicked: boolean;
	@Output() iEnviarErpBtnClicked: boolean;

	@Output() onChangeEvent: EventEmitter<any> = new EventEmitter();

	dataTermino: any;
	dataAnulacion: any;
	prefacStateclass: string;
	isCanceledBill: boolean;
	isSentErpBill: boolean;

	constructor(private router: Router, private errorService: ErrorService,
    private notificationService: NotificationService, private loaderService: LoaderService,
    //private contratoService: ContratoService, private promotorService: PromotorService,
    //private prefacturaService: PrefacturaService, private cronogramaService: CronogramaService,
		private commonCboService: CommonCboService
	) { }

	ngOnInit() {
		this.iAnularBtnClicked = false;
		this.iEnviarERP = false;
		this.isCanceledBill =  false;
		if (this.data && this.data.prefactura && this.data.prefactura.tipEstPrefactura == 5) //Anulado
			this.isCanceledBill =  true;

		this.isSentErpBill =  false;
		if (this.data && this.data.prefactura && this.data.prefactura.tipEstPrefactura == 3) //Enviado ERP
			this.isSentErpBill =  true;

		if(this.loadMotivos){
			//this.listarMotivoTerminoCbo();
			//this.listarMotivoAnulacionCbo();
		}
	}
  /*
	private anularPrefactura() {
        this.loaderService.show();
        this.prefacturaService.anularPrefactura(this.data.prefactura.codPrefactura)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
					this.data.prefactura.tipEstPrefactura = CONSTANT.tipEstadoPrefactura.anulado;
					this.isCanceledBill = true;
					this.iAnularPrefactura = false;
					this.iEnviarERP = false;
					this.iEdit = false;
					this.data.prefactura.isAnuladoFromActionToPrefactura = true;
					this.data.prefactura.isAnuladoFromActionToConcepto = true;
                }
            },
            error => {
                this.notificationService.error('Error al anular la prefactura.');
                throw error;
            },
            () => {
				this.loaderService.hide();
				this.changeEvent({ evento: EVENTO.view, data: this.data });
			}
		);
  }

	private envioNotaCreditoCuota(Prefacturas: string): void {
        this.loaderService.show();
        this.cronogramaService.envioNotaCreditoCuota(Prefacturas)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res))
					this.enviarErp();
            },
            error => {
                this.notificationService.error('Error al enviar la nota de crédito.');
            },
            () => {
                //this.listarCronograma(codContrato, codAdenda);
				this.loaderService.hide();
				this.changeEvent({ evento: EVENTO.view, data: this.data });
            }
        );
	}

	private envioPreFacturaCuota(Prefacturas: string): void {
        this.loaderService.show();
        this.cronogramaService.envioPreFacturaCuota(Prefacturas)
            .subscribe(res => {
				if (this.errorService.getResultMessageError2(res))
					this.enviarErp();
            },
            error => {
                this.notificationService.error('Error al enviar la pre-factura.');
            },
            () => {
                //this.listarCronograma(codContrato, codAdenda);
				this.loaderService.hide();
            }
        );
    }
	private enviarErp() {
        this.loaderService.show();
        this.prefacturaService.enviarErp(this.data.prefactura.codPrefactura)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
					this.data.prefactura.tipEstPrefactura = CONSTANT.tipEstadoPrefactura.enviadoerp;
					this.isSentErpBill = true;
					this.iAnularPrefactura = false;
					this.iEnviarERP = false;
					this.iEdit = false;
					this.data.prefactura.isAnuladoFromActionToPrefactura = true;
					this.data.prefactura.isAnuladoFromActionToConcepto = true;
                }
            },
            error => {
                this.notificationService.error('Error al enviar la prefactura al ERP.');
                throw error;
            },
            () => {
				this.loaderService.hide();
				this.changeEvent({ evento: EVENTO.view, data: this.data });
			}
		);
	}
  */

	onEnviarERP(){
		//this.enviarErp();
		// if(this.data.prefactura.tipDocumentoEmitir == CONSTANT.tipDocumentoEmitir.notacredito)
		// 	this.envioNotaCreditoCuota(this.data.prefactura.codPrefactura);
		// else
		// 	this.envioPreFacturaCuota(this.data.prefactura.codPrefactura);
	}

	onAnularPrefactura(){
		//this.anularPrefactura();
	}

	onHeader(event: any) {
		if (event)
			this.changeEvent({ evento: event, data: this.data });
		if (event === 0)
			this.changeEvent({ evento: event, data: this.data });
	}

	onCancel() {
		this.changeEvent({ evento: this.eventCancel, data: this.data });
	}

	onEdit() {
		this.changeEvent({ evento: this.eventEdit, data: this.data });
	}

	onBack() {
		this.changeEvent({ evento: this.eventBack, data: this.data });
	}

	onClose() {
		this.isCanceledBill =  false;
		this.isSentErpBill = false;
		this.router.navigate([this.eventClose]);
	}

	onCloseEvent() {
		this.changeEvent({ evento: this.eventCloseEvent, data: {} });
	}

	changeEvent(evento: any) {
		this.onChangeEvent.emit(evento);
	}

	onTerminarContrato(codReason: number){
		//this.terminarContrato(this.data.contrato.codContrato, codReason);
	}

	onAnularContrato(codReason: number){
		//this.anularContrato(this.data.contrato.codContrato, codReason);
	}

	onDarBaja(){
		//this.darBaja();
	}

	onDarBajaPromotor(){
		//this.darBajaPromotor();
	}

  /** Contrato */
  /*
	private darBajaPromotor() {
        this.loaderService.show();
        this.promotorService.darBajaPromotor(this.data.promotor.codComisionPromotor)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                    this.changeEvent({ evento: this.eventBack });
                }
            },
            error => {
                this.notificationService.error('Error al eliminar el promotor.');
                throw error;
            },
            () => {
                this.loaderService.hide();
			}
		);
	}

	private darBaja() {
        this.loaderService.show();
        this.contratoService.darBaja(this.data.afiliado.codMovimiento)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                    this.changeEvent({ evento: this.eventBack });
                }
            },
            error => {
                this.notificationService.error('Error al dar de baja al afiliado.');
                throw error;
            },
            () => {
                this.loaderService.hide();
            });
	}

	private terminarContrato(codContrato: number, codReason: number) {
        this.loaderService.show();
        this.contratoService.terminarContrato(codContrato, codReason)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                    this.changeEvent({ evento: this.eventCloseEvent });
                }
            },
            error => {
                this.notificationService.error('Error al terminar el contrato');
                throw error;
            },
            () => {
                this.loaderService.hide();
            });
	}

	private anularContrato(codContrato: number, codReason: number) {
        this.loaderService.show();
        this.contratoService.anularContrato(codContrato, codReason)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                    this.changeEvent({ evento: this.eventCloseEvent });
                }
            },
            error => {
                this.notificationService.error('Error al anular el contrato');
                throw error;
            },
            () => {
                this.loaderService.hide();
            });
	}

	private listarMotivoTerminoCbo(): void {
        this.loaderService.show();
        this.commonCboService.listarMotivoTerminoCbo()
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                    this.dataTermino = res.Data;
                }
            },
            error => {
                this.notificationService.error(this.commonCboService.msgErrorListarMotivoTerminoCbo);
                throw error;
            },
            () => {
                this.loaderService.hide();
            });
	}

	private listarMotivoAnulacionCbo(): void {
        this.loaderService.show();
        this.commonCboService.listarMotivoAnulacionCbo()
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                    this.dataAnulacion = res.Data;
                }
            },
            error => {
                this.notificationService.error(this.commonCboService.msgErrorListarMotivoAnulacionCbo);
                throw error;
            },
            () => {
                this.loaderService.hide();
            });
	}
  */

	onRegeneraCronogramaContrato(){
		//this.generaCronogramaContrato(this.data.contrato.codContrato, this.data.contrato.lastCodAdenda);
  }
  /*
    private generaCronogramaContrato(codContrato: number, codAdenda: number): void {
        this.loaderService.show();
        this.contratoService.generaCronogramaContrato(codContrato, codAdenda)
            .subscribe(res => {
                if (this.errorService.getResultMessageError2(res)) {
                }
            },
            error => {
                this.notificationService.error("Error al renegerar cronorgrama.");
            },
            () => {
                this.loaderService.hide();
            }
        );
    }
    */
}
